import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22a1 1 0 0 1-.71-.29l-9-9a1.004 1.004 0 0 1 1.42-1.42L11 18.589V3a1 1 0 0 1 2 0v15.589l7.29-7.299a1.004 1.004 0 1 1 1.42 1.42l-9 9A1 1 0 0 1 12 22"
    />
  </svg>
);
export default SvgArrowDown;
